export const SAVE_PLANS = (state, val) => {
  state.plans = val;
}

export const ADD_PLAN = (state, val) => {
  state.plans.push(val);
}

export const UPDATE_PLAN = (state, val) => {
  let index = state.plans.findIndex(plan => plan.id == val.id);
  state.plans[index] = val;
}

export const REMOVE_PLAN = (state, id) => {
  let index = state.plans.findIndex(plan => plan.id == id);
  state.plans.splice(index, 1);
}

export const ADD_CONF_ROOM = (state, val) => {
  let index = state.plans.findIndex(plan => plan.id == val.params.planId);

  state.plans[index].conference_rooms.push(val.res.conf_room);
}

export const UPDATE_CONF_ROOM = (state, val) => {
  let index = state.plans.findIndex(plan => plan.id == val.params.planId);
  let roomIndex = state.plans[index].conference_rooms.findIndex(room => room.id == val.params.roomId);;

  state.plans[index].conference_rooms[roomIndex] = val.res.conf_room;
}

export const REMOVE_CONF_ROOM = (state, val) => {
  let index = state.plans.findIndex(plan => plan.id == val.planId);
  let roomIndex = state.plans[index].conference_rooms.findIndex(room => room.id == val.roomId);;

  state.plans[index].conference_rooms.splice(roomIndex, 1);
}
